module.exports = __webpack_public_path__ + "media/images/element/01-70e48fa5dee67d8a06c5ff87cbb4b699.svg";